import { useEffect } from "react";
import parse from "html-react-parser";

const PreviewComponent = ({ sectionHtml, theme }) => {
  useEffect(() => {
    if (sectionHtml) {
      console.log("section html------------->", sectionHtml);
      console.log("theme", theme.primaryColor);
    }
  }, [sectionHtml, theme]);

  let rootProcessed = false; // ← Add this outside transform to track root

  const transform = (node) => {
    if (node.attribs) {
      // Add pointerEvents and color to the first root element only
      if (!rootProcessed) {
        node.attribs.style = node.attribs.style
          ? `${node.attribs.style}; color: ${theme.primaryColor}; pointer-events: none;`
          : `color: ${theme.primaryColor}; pointer-events: none;`;
        rootProcessed = true;
      }

      // Replace class names
      if (node.attribs.class) {
        node.attribs.class = node.attribs.class.replace("container mx-auto", "px-2");
        node.attribs.class = node.attribs.class.replace("max-w-[1600px]", "");
      }

      // Remove type="submit"
      if (node.attribs.type?.includes("submit")) {
        console.log("submit removed");
        delete node.attribs.type;
      }
    }
    return node;
  };
  const cleanHtml = sectionHtml?.replace(/undefined/g, '') ?? '';

  return <>{cleanHtml ? parse(cleanHtml, { replace: transform }) : null}</>;
};

export default PreviewComponent;
